<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  ООО «РЕСУРС» – стабильная развивающаяся компания, которая
                  прочно заняла лидирующую роль на топливном рынке России.
                </p>

                <p>
                  Одно из преимуществ компании — профессиональный и слаженный
                  коллектив с большим опытом работы. Коллектив компании ООО
                  «Ресурс» несет ответственность перед партнерами и всегда
                  выполняет свои обязательства. Уровень сервиса, который
                  получают наши клиенты, напрямую зависит от качества работы с
                  партнерами. Мы тщательно отбираем партнеров-НПЗ и строим с
                  ними долгосрочные, взаимовыгодные отношения.
                </p>
                <p>
                  Мы используем современные ИТ-решения и индивидуально работаем
                  с каждым клиентом. Постоянно внедряем новые инструменты и
                  сервисы, добавляем новый функционал, предоставляемый клиентам.
                  Расширяем географию работы.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:88006006954"
                          class="ViewPromo__advantage-contact-link"
                          >8(800) 600-69-54</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:SALE@RES-RS.ru"
                          class="ViewPromo__advantage-contact-link"
                          >SALE@RES-RS.ru</a
                        ></strong
                      >
                    </p>
                    <p>
                      Веб-сайт:<br />
                      <strong
                        ><a
                          href="https://www.res-rs.ru"
                          target="_blank"
                          class="ViewPromo__advantage-contact-link"
                          >https://www.res-rs.ru</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы поставок</h4>
                    <p>
                      Володарская ЛПДС, Московский НПЗ, ЛПДС Невская, ЛПДС
                      Воронеж
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «РЕСУРС»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 450,
    productId: 1037,
    name: 'ООО «РЕСУРС»',
    inn: '4004021062 ',
  }),
};
</script>
